export const FETCH_DATA = 'FETCH_DATA';
export const SELECT_COLUMN = 'SELECT_COLUMN';
export const TOGGLE_SETTINGS = 'TOGGLE_SETTINGS';
export const FETCH_APP_NAME = 'FETCH_APP_NAME';
export const SET_ERROR = 'SET_ERROR';
